import { isEmail, isPhoneNumber } from 'helpers';
import { AppContext } from 'providers/AppContext';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useSWR from 'swr';
import type { Member } from 'types';

export function useParents() {
	const ctx = useContext(AppContext);
	const { config, http, navigate, state, t } = ctx;
	const { entityType, flowType } = useParams();
	const [formErrors, setFormErrors] = useState<Record<string, string>>({});
	const processId = `${state.context.processInfo?.agreementProcessId}`;
	const initiatorSsn = state.context.kennitala;
	const nextPage = `/${flowType}/${entityType}/mandate`;
	const urlMembers = `${config.API.member}/${processId}/GetMembers`;
	const { data, mutate } = useSWR<Member[]>(urlMembers);

	const submitForm = async () => {
		const email = (document.getElementsByName('email')[0] as HTMLInputElement).value;
		const phoneNumber = (document.getElementsByName('phone')[0] as HTMLInputElement).value;
		const errors: Record<string, string> = {};
		if (!isEmail(email)) {
			errors.email = t('INVALID_EMAIL');
		}
		if (!isPhoneNumber(phoneNumber)) {
			errors.phone = t('INVALID_PHONE_NUMBER');
		}
		if (Object.keys(errors).length) {
			setFormErrors(errors);
		} else {
			const kennitala = Array.isArray(data) && data[1] ? data[1].kennitala : null;
			const payload = { email, phoneNumber, kennitala, initiatorSsn };
			const updateURL = `${config.API.member}/${processId}/UpdateMemberEmail`;
			await http.put(updateURL, payload, undefined, t('submit'));
			await mutate();
			navigate(nextPage);
		}
	};

	useEffect(() => {
		Array.isArray(data) && data.length < 2 && navigate(nextPage);
	}, [data, nextPage]); // eslint-disable-line react-hooks/exhaustive-deps

	return { ...ctx, data, formErrors, submitForm };
}
